type Product = 'datagrid' | 'datasynth';

export type NavLink = { label: string; href: string };

const products: { id: Product; label: string; path: string }[] = [
  { id: 'datagrid', label: 'datagrid', path: '/' },
  { id: 'datasynth', label: 'datasynth', path: '/datasynth' },
];

export function SiteNav({
  product,
  links,
  ctaHref,
  ctaLabel,
}: {
  product: Product;
  links: NavLink[];
  ctaHref: string;
  ctaLabel: string;
}) {
  return (
    <header>
      <nav className="nav wrap">
        <a className="nav-brand" href={product === 'datagrid' ? '/' : '/datasynth'} aria-label="vibelibs home">
          <span className="nav-brand-mark">vl</span>
          <span>vibelibs</span>
        </a>
        <div className="nav-products" role="tablist" aria-label="Choose a product">
          {products.map((p) => (
            <a
              key={p.id}
              role="tab"
              aria-selected={product === p.id}
              className={`nav-product${product === p.id ? ' is-active' : ''}`}
              href={p.path}
            >
              {p.label}
            </a>
          ))}
        </div>
        <div className="nav-links">
          {links.map((l) => (
            <a key={l.href} href={l.href}>{l.label}</a>
          ))}
        </div>
        <a className="nav-cta" href={ctaHref}>{ctaLabel}</a>
      </nav>
    </header>
  );
}
